export default __webpack_public_path__ + "static/media/screen_facebook_1_2.3e99fdc1.png";